module.exports = __webpack_public_path__ + "media/images/client_logos/logo_mcdonalds_200-3365ea01e8d053dc2c9b70fe763014b8.png";